<div class="p-grid p-justify-center">
  <cre-spinner [size]="'md'" *ngIf="!bonusStat"></cre-spinner>
</div>
<div class="cre-bonus-summary" *ngIf="bonusStat">
  <div class="bonus-icon" *ngIf="displayIcon()">
    <fa-icon [icon]="getIcon()"></fa-icon>
  </div>
  <div class="bonus-header">{{ bonusStat.heading }}</div>
  <div class="bonus-message">
    {{ bonusStat.description }}
  </div>
  <div class="p-grid p-justify-center">
    <cre-spinner [size]="'md'" [hidden]="!isLoadingDriverStat"></cre-spinner>
  </div>
  <div [hidden]="isLoadingDriverStat" class="commitment-container" *ngIf="driverStat">
    <div
      class="bonus-commitments"
      (click)="displaySideBar('No Accidents or Critical Events', driverStat.finalSafetyBonusText)"
    >
      <div>
        <div class="card">
          <div class="head">
            <span class="header">Safety (Accident, Critical Events, and Log/CSA Violations)</span>
            <span
              class="status"
              [ngClass]="getStatusClass(driverStat.finalSafetyBonusText)"
            >{{
              driverStat.finalSafetyBonusText
              }}</span>
          </div>
          <span class="next-month">{{ getMonth() }}</span>
          <div class="progress">
            <div class="progress-bar">
              <app-progress-bar
                [value1]="getProgressValue1(driverStat.finalSafetyBonusText)"
                [value2]="getProgressValue2(driverStat.finalSafetyBonusText)"
                [showValues]="false"
              ></app-progress-bar>
            </div>
            <span
              class="cpm"
              [ngClass]="IsLineThrough(driverStat.finalSafetyBonusText)"
            >{{
              getPaymentUnit()
              }}</span>
          </div>
        </div>
      </div>
    </div>
    <div
      class="bonus-commitments"
      (click)="displaySideBar('No Late Arrivals', driverStat.finalOnTimeBonusText)"
    >
      <div class="card">
        <div class="head">
          <span class="header">Service (On-time, DVIR, Paperwork)</span>
          <span class="status" [ngClass]="getStatusClass(driverStat.finalOnTimeBonusText)">{{
            driverStat.finalOnTimeBonusText
          }}</span>
        </div>
        <span class="next-month">{{ getMonth() }}</span>
        <div class="progress">
          <div class="progress-bar">
            <app-progress-bar
              [value1]="getProgressValue1(driverStat.finalOnTimeBonusText)"
              [value2]="getProgressValue2(driverStat.finalOnTimeBonusText)"
              [showValues]="false"
            ></app-progress-bar>
          </div>
          <span class="cpm" [ngClass]="IsLineThrough(driverStat.finalOnTimeBonusText)">{{
            getPaymentUnit()
          }}</span>
        </div>
      </div>
    </div>
    <div
      class="bonus-commitments"
      (click)="
            displaySideBar('All Commitments, Huddles, Safety Video', driverStat.finalCommitBonusText)
          "
    >
      <div>
          <div class="card">
            <div class="head">
              <span class="header">All Commitments, Huddles, Safety Video</span>
              <span
                class="status"
                [ngClass]="getStatusClass(driverStat.finalCommitBonusText)"
              >{{
                driverStat.finalCommitBonusText
                }}</span>
            </div>
            <span class="next-month">{{ getMonth() }}</span>
            <div class="progress">
              <div class="progress-bar">
                <app-progress-bar
                  [value1]="getCommitmentValue1()"
                  [value2]="getCommitmentValue2()"
                  [showValues]="false"
                ></app-progress-bar>
              </div>
              <span
                class="cpm"
                [ngClass]="IsLineThrough(driverStat.finalCommitBonusText)"
              >{{
                getPaymentUnit()
                }}</span>
            </div>
          </div>
      </div>
    </div>
  </div>
</div>

<p-sidebar
  [blockScroll]="true"
  (onHide)="clearSidebar()"
  position="bottom"
  [showCloseIcon]="true"
  styleClass="cre-bonus-status-sidebar"
  [(visible)]="isSidebarVisible"
>
  <div class="title">
    <p class="sideBarTitle">{{ sideBarTitle }}</p>
  </div>
  <div class="body">
    <p class="lorem">{{ description }}</p>
    <p class="lorem">{{ status }}</p>
  </div>
</p-sidebar>
